import theaspen from "../../../../public/projects/whiteland/projects/theaspen.webp";
import urbanresort from "../../../../public/projects/whiteland/projects/urbanresort.webp";
import logo from "../../../../public/projects/whiteland/logo/logo.png";

//aspen
import overviewImage_theaspen from "../../../../public/projects/whiteland/images/theaspen/Overview/1.webp";
import bannerDesktopImage_theaspen from "../../../../public/projects/whiteland/images/theaspen/Banner/1.webp";
import bannerMobileImage_theaspen from "../../../../public/projects/whiteland/images/theaspen/Banner/2.webp";
import siteVisitBannerImage_theaspen from "../../../../public/projects/whiteland/images/theaspen/SiteVisitBanner/1.webp";
import Location_theaspen from "../../../../public/projects/whiteland/images/theaspen/Location/L1.webp";
import Hightlights_theaspen from "../../../../public/projects/whiteland/images/theaspen/Highlights/1.webp";
import image1BHK_theaspen from "../../../../public/projects/whiteland/images/theaspen/floorplan/1.webp";
import image2BHK_theaspen from "../../../../public/projects/whiteland/images/theaspen/floorplan/2.webp";
import image3BHK_theaspen from "../../../../public/projects/whiteland/images/theaspen/floorplan/3.webp";
import location_theaspen from "../../../../public/projects/whiteland/images/theaspen/Overview/l.png";
import cal_theaspen from "../../../../public/projects/whiteland/images/theaspen/Overview/c.png";
import newlaunch_theaspen from "../../../../public/projects/whiteland/images/theaspen/Overview/n.png";
import g1_theaspen from "../../../../public/projects/whiteland/images/theaspen/Gallery/1.webp";
import g2_theaspen from "../../../../public/projects/whiteland/images/theaspen/Gallery/2.webp";
import g3_theaspen from "../../../../public/projects/whiteland/images/theaspen/Gallery/3.webp";
import g4_theaspen from "../../../../public/projects/whiteland/images/theaspen/Gallery/4.webp";
import g5_theaspen from "../../../../public/projects/whiteland/images/theaspen/Gallery/5.webp";

//urbanresort
import overviewImage_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Overview/1.webp";
import bannerDesktopImage_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Banner/1.webp";
import bannerMobileImage_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Banner/2.webp";
import siteVisitBannerImage_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/SiteVisitBanner/1.webp";
import Location_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Location/L1.webp";
import Hightlights_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Highlights/1.webp";
import image1BHK_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/floorplan/1.webp";
import image2BHK_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/floorplan/2.webp";
import image3BHK_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/floorplan/3.webp";
import location_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Overview/l.png";
import cal_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Overview/c.png";
import newlaunch_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Overview/n.png";
import g1_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Gallery/1.webp";
import g2_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Gallery/2.webp";
import g3_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Gallery/3.webp";
import g4_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Gallery/4.webp";
import g5_urbanresort from "../../../../public/projects/whiteland/images/urbanresort/Gallery/5.webp";

export const developersWhiteland = {
  name: `Whiteland Properties in Gurugram`,
  properties: [
    {
      name: "Whiteland Urban Resort",
      image: urbanresort,
      price: " 7.23 Cr",
      location: "Sector 103, Gurugram",
      state: "Gurugram",
      projectlocation: "",
      developer: "Whiteland",
      bed: "3 - 4 BHK",
      size: "2809 Sq.Ft",
      url: `/urban-resort-sector-103-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Whiteland Urban Resort", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Whiteland The Aspen",
      image: theaspen,
      price: " 3.44 Cr*",
      location: "Sector 76, Gurugram",
      state: "Gurugram",
      developer: "Whiteland",
      bed: "3,4 & 5 BHK",
      size: "2290 Sq.Ft.",
      projectlocation: "Dwarka Expressway",
      url: `/whiteland-aspen-sector-76-gurugram`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Whiteland The Aspen", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: `5 years`,
    projects: `20`,
    ongoingprojects: `5`,
  },
  about: `Whiteland is a renowned real estate developer in India, known for its luxury residential and 
  commercial projects. The company focuses on delivering high-quality developments with modern architecture, 
  innovative designs, and sustainable construction practices. Whiteland aims to create exceptional living and working
   spaces that enhance urban lifestyles and provide long-term value.`,
};

export const projectswhiteland = {
  aspen: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_theaspen,
      bannerMobileImage: bannerMobileImage_theaspen,
      textOverlay: "",
      data: {
        title: "Whiteland The Aspen",
        subtitle: "  Sector 76, Gurugram",
        starting_price: "₹ 3.44 Cr*",
        rerano: "GGM/663/395/2023/07",
        payment_plan: "....",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Whiteland The Aspen",
      description: [
        `Explore Whiteland The Aspen in Sector 76, one of the new housing societies currently under construction in Gurugram. Apartments are available for purchase in Whiteland The Aspen, Sector 76, Gurugram. This society will offer all essential facilities and amenities to cater to the needs and preferences of homebuyers. Developed by Whiteland Corporation, Whiteland The Aspen is anticipated to be ready for possession in December 2030. 

As a RERA-registered society, the project details and other crucial information can also be found on the state RERA portal. The RERA registration number for this project is GGM/663/395/2023/07. 

Whiteland Corporation is a reputed name in the Gurugram real estate market, with about four upcoming projects.


`,
      ],
      image: overviewImage_theaspen,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_theaspen,
          title: "₹ 3.44 Cr*",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_theaspen,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_theaspen,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_theaspen,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2290 Sq.Ft.",
          price: "₹ 3.44  Cr",
        },
        {
          type: "4 BHK",
          area: "3243 Sq.Ft.",
          price: "₹ 4.86  Cr ",
        },
        {
          type: "5 BHK",
          area: "6096  Sq.Ft.",
          price: "₹ 9.14  Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2290 Sq.Ft.",
        price: "₹ 3.44  Cr",
        image: image1BHK_theaspen,
      },
      {
        type: "4 BHK",
        area: "3243 Sq.Ft.",
        price: "₹ 4.86  Cr",
        image: image2BHK_theaspen,
      },
      {
        type: "5 BHK",
        area: "6096  Sq.Ft.",
        price: "₹ 9.14  Cr",
        image: image3BHK_theaspen,
      },
    ],

    highlights: {
      images: Hightlights_theaspen,
      tagline: "Highlights",
      features: [
        "The project is spread over an area of 20.7 acres.",
        "Whiteland The Aspen Sector 76 housing society has 9 towers with 42 floors",
        "Stunning panoramas of the Aravalli range and the city skyline",
        "Architecture adhering to Vastu principles",
        "Properties offering complete power backup options available",
      ],
    },

    location: {
      image: Location_theaspen,
      data: [
        {
          airport: {
            distance_time: "26.4 kms",
            name: " IGI Airport"
          },
          school: {
            distance_time: "2.9 Kms",
            name: "Vega School"
          },
          railwayormetro: {
            distance_time: "11.4 Kms",
            name: "Garhi Junction"
          },
          hospital: {
            distance_time: "2 Kms",
            name: "Apollo Cradle"
          },
          mall: {
            distance_time: "4.9 Kms",
            name: "Sapphire 83 Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_theaspen },
        { image: g2_theaspen },
        { image: g3_theaspen },
        { image: g4_theaspen },
        { image: g5_theaspen },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Whiteland The Aspen, kindly share more details.",
    },

    faq: [
      {
        question: "What makes Whiteland The Aspen a standout choice for homebuyers?",
        answer: `Whiteland The Aspen in Sector 76, Gurugram, is a standout choice for homebuyers seeking a blend of luxury, modern living, and prime connectivity.`,
      },
      {
        question: "Where is Whiteland The Aspen located?",
        answer: `The project is situated in Sector 76, Gurugram, with excellent connectivity to NH-8, Golf Course Extension Road, and major business hubs.`,
      },
      {
        question: "What types of apartments are available at Whiteland The Aspen?",
        answer: `It offers spacious 3BHK, 4BHK, and penthouse apartments with modern architecture and luxury features.`,
      },
      {
        question: "What are the key amenities in Whiteland The Aspen?",
        answer: `Amenities include a clubhouse, swimming pool, gym, landscaped gardens, jogging tracks, sports courts, and 24/7 security.`,
      },
      {
        question: "What is the starting price of apartments at Whiteland The Aspen?",
        answer: `The price varies based on unit type and configuration, but it starts from approximately ₹3.5 crore.`,
      },
      {
        question: "Who is the developer of Whiteland The Aspen?",
        answer: `The project is developed by Whiteland Corporation, known for its high-end residential and commercial developments.`,
      },
      {
        question: "Is Whiteland The Aspen RERA approved?",
        answer: `Yes, the project is RERA registered, ensuring transparency and compliance with legal norms.`,
      },
      {
        question: "What is the possession date for Whiteland The Aspen?",
        answer: `The expected possession date is 2027, subject to construction progress.`,
      },
      {
        question: "How well is Whiteland The Aspen connected to major locations?",
        answer: `The project is close to NH-8, SPR Road, and Dwarka Expressway, providing seamless connectivity to Delhi, IGI Airport, and Cyber City.`,
      },
      {
        question: "What makes Whiteland The Aspen a good investment?",
        answer: `It offers luxury living, a prime location, high appreciation potential, and top-notch amenities, making it an excellent investment option.`,
      },
    ],
    similar: {
      properties: [

        {
          name: "Whiteland Urban Resort",
          image: urbanresort,
          price: "  7.23 Cr",
          location: "Sector 103, Gurugram",
          state: "Gurugram",
          projectlocation: "",
          developer: "Whiteland",
          bed: "3 - 4 BHK",
          size: "2809 Sq.Ft",
          url: `/urban-resort-sector-103-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Whiteland Urban Resort", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  urbanresort: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_urbanresort,
      bannerMobileImage: bannerMobileImage_urbanresort,
      textOverlay: "",
      data: {
        title: "Whiteland Westin Residences",
        subtitle: "Sector 103, Gurugram",
        starting_price: "₹26.12 K/Sq.Ft",
        rerano: "GGM/838/570/2024/65",
        payment_plan: "....",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Whiteland Westin Residences",
      description: [
        `Whiteland Westin Residences is the latest luxury apartment project introduced in Sector 103, Dwarka Expressway, Gurugram.

The development consists of spacious 3 and 4 BHK apartments, with sizes ranging from 2,500 to 4,200 sq. ft. Each unit boasts large windows and balconies, allowing ample natural light and ventilation.

Whiteland Westin Residences Gurugram provides an opulent living environment spread over 12 acres, featuring 11 towers and 600 residences. More than 70% of the space is dedicated to open and green areas, complemented by stunning landscapes that enhance its appeal and exclusivity.

The residences will be overseen by the esteemed Westin Group, ensuring high-quality hospitality services for the residents. The developer is dedicated to upholding superior construction standards, providing a living experience that merges luxury with longevity, crafted to align with the highest benchmarks of excellence.

Amenities at Whiteland Westin Residences include a fully equipped clubhouse, picturesque gardens, a gym, a swimming pool, recreational rooms, outdoor sports courts, and a designated play area for children. Additionally, a party hall is available, and the entire community is designed with top-notch 24/7 security to guarantee residents' safety.`,
      ],
      image: overviewImage_urbanresort,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_urbanresort,
          title: "₹ 7.23 Cr",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_urbanresort,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_urbanresort,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_urbanresort,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2809 Sq.Ft",
          price: "₹ 7.23 Cr",
        },
        {
          type: "4BHK",
          area: "3809 Sq.Ft",
          price: "₹ 10.1 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2809 Sq.Ft",
        price: "₹ 7.23 Cr",
        image: image1BHK_urbanresort,
      },
      {
        type: "4BHK",
        area: "3809 Sq.Ft",
        price: "₹ 10.1 Cr",
        image: image2BHK_urbanresort,
      },
    ],

    highlights: {
      images: Hightlights_urbanresort,
      tagline: "Highlights",
      features: [
        "There are five luxurious clubhouses with a  area of 1.75 million square feet.",
        "Luxurious living with top-quality specifications, deck balconies.",
        "A unique range of specifications, such as a fully-load modular kitchen.",
        "80% Green Space",
        "Three-Story Lobby",
      ],
    },

    location: {
      image: Location_urbanresort,
      data: [
        {
          airport: {
            distance_time: "25.6 kms",
            name: " IGI Airport"
          },
          school: {
            distance_time: "2.8 Kms",
            name: " DPS"
          },
          railwayormetro: {
            distance_time: "7.3 Kms",
            name: "Palam  Halt"
          },
          hospital: {
            distance_time: "3.9 Kms",
            name: "  Chirag Hospital"
          },
          mall: {
            distance_time: "5 Kms",
            name: " WTC Plaza"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_urbanresort },
        { image: g2_urbanresort },
        { image: g3_urbanresort },
        { image: g4_urbanresort },
        { image: g5_urbanresort },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Whiteland Westin Residences, kindly share more details.",
    },

    faq: [

      {
        question: "Where is Whiteland Westin Residences located?",
        answer: `It is strategically located in Sector 103, Gurugram, near the Dwarka Expressway, providing excellent connectivity to Delhi, IGI Airport, and other key areas.`,
      },
      {
        question: "What types of residences are available at Whiteland Westin Residences?",
        answer: `The project offers high-end luxury apartments with spacious layouts, modern interiors, and premium finishes to ensure a lavish lifestyle.`,
      },
      {
        question: "What are the key amenities of Whiteland Westin Residences?",
        answer: `The project features resort-style amenities, including a clubhouse, swimming pool, landscaped gardens, a fitness center, sports courts, and wellness facilities.`,
      },
      {
        question: "Is Whiteland Westin Residences RERA-approved?",
        answer: `Yes, Whiteland Westin Residences is RERA-registered, ensuring transparency and compliance with real estate regulations.`,
      },
      {
        question: "What makes Whiteland Westin Residences unique?",
        answer: `It stands out for its resort-inspired design, lush greenery, ultra-modern facilities, and a serene environment that offers a vacation-like living experience.`,
      },
      {
        question: "How well is Whiteland Westin Residences connected to major roads and highways?",
        answer: `The project is well-connected via Dwarka Expressway, NH-8, and Pataudi Road, providing seamless access to Delhi, IGI Airport, and business hubs in Gurugram.`,
      },
      {
        question: "What makes Whiteland Westin Residences a standout choice for homebuyers?",
        answer: `Whiteland Westin Residences in Sector 103, Gurugram, stands out as a top choice for homebuyers seeking a luxurious and nature-inspired living experience.`,
      },
      {
        question: "Who is the developer of Whiteland Westin Residences?",
        answer: `Whiteland Corporation, a reputed real estate developer known for premium residential projects, is behind this luxurious development.`,
      },
      {
        question: "Is there any security and surveillance at Whiteland Westin Residences?",
        answer: `Yes, the community is equipped with 24/7 security, CCTV surveillance, and controlled access points for residents' safety.`,
      },
      {
        question: "Are there any payment plans or financing options available?",
        answer: `Yes, the project offers flexible payment plans, and home loans can be availed from leading banks and financial institutions.`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Whiteland The Aspen",
          image: theaspen,
          price: " 3.44 Cr*",
          location: "Sector 76, Gurugram",
          state: "Gurugram",
          developer: "Whiteland",
          bed: "3,4 & 5 BHK",
          size: "2290 Sq.Ft.",
          projectlocation: "Dwarka Expressway",
          url: `/whiteland-aspen-sector-76-gurugram`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Whiteland The Aspen", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
